import React from 'react';
import BackButton from './BackButton';

function AdminPage({ setPage, user, freeMode, toggleFreeMode, cacheStats, allUsers, loadAllUsers }) {
  
  // Load users on mount if needed
  React.useEffect(() => {
    if (allUsers.length === 0) {
      loadAllUsers();
    }
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      <header style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e0e0e0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <img
            src="/logo.svg"
            alt="PatTrak Logo"
            style={{
              height: '32px',
              cursor: 'pointer'
            }}
            onClick={() => setPage('search')}
          />
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1d2934' }}>Admin Dashboard</h1>
        </div>
        <BackButton onClick={() => setPage('search')} />
      </header>

      <main style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 16px' }}>
        <div style={{ background: '#f5f5f5', padding: '24px', borderRadius: '8px', marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1d2934', marginBottom: '16px' }}>Free Mode</h2>
          <p style={{ color: '#5e778a', marginBottom: '16px' }}>
            {freeMode ? 'All users have full access (testing mode)' : 'Normal subscription tiers apply'}
          </p>
          <button
            onClick={toggleFreeMode}
            style={{
              background: freeMode ? '#ff4444' : '#53dafc',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '4px',
              border: 'none',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            {freeMode ? 'Disable Free Mode' : 'Enable Free Mode'}
          </button>
        </div>

        {/* Cache Statistics */}
        <div style={{ background: '#f5f5f5', padding: '24px', borderRadius: '8px', marginBottom: '32px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1d2934', marginBottom: '16px' }}>
            Cache Statistics
          </h2>

          {cacheStats ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
              <div style={{ background: '#e3f2fd', padding: '20px', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#1976d2' }}>
                  {cacheStats.total_entries}
                </div>
                <div style={{ fontSize: '14px', color: '#5e778a', marginTop: '8px' }}>
                  Cached Analyses
                </div>
              </div>

              <div style={{ background: '#e8f5e9', padding: '20px', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#388e3c' }}>
                  {cacheStats.total_access_count}
                </div>
                <div style={{ fontSize: '14px', color: '#5e778a', marginTop: '8px' }}>
                  Total Accesses
                </div>
              </div>

              <div style={{ background: '#f3e5f5', padding: '20px', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#7b1fa2' }}>
                  ${cacheStats.estimated_savings}
                </div>
                <div style={{ fontSize: '14px', color: '#5e778a', marginTop: '8px' }}>
                  Cost Savings
                </div>
              </div>

              <div style={{ background: '#fff3e0', padding: '20px', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#f57c00' }}>
                  {cacheStats.avg_access_count}
                </div>
                <div style={{ fontSize: '14px', color: '#5e778a', marginTop: '8px' }}>
                  Avg Accesses/Patent
                </div>
              </div>

              <div style={{ background: '#e8eaf6', padding: '20px', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#3f51b5' }}>
                  {cacheStats.oldest_entry_days}
                </div>
                <div style={{ fontSize: '14px', color: '#5e778a', marginTop: '8px' }}>
                  Oldest Entry (days)
                </div>
              </div>

              <div style={{ background: '#fce4ec', padding: '20px', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#c2185b' }}>
                  {cacheStats.newest_entry_days}
                </div>
                <div style={{ fontSize: '14px', color: '#5e778a', marginTop: '8px' }}>
                  Newest Entry (days)
                </div>
              </div>
            </div>
          ) : (
            <div style={{ color: '#5e778a' }}>Loading cache statistics...</div>
          )}
        </div>

        <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1d2934', marginBottom: '16px' }}>All Users</h2>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #e0e0e0' }}>
                <th style={{ padding: '12px', textAlign: 'left', color: '#1d2934' }}>Email</th>
                <th style={{ padding: '12px', textAlign: 'left', color: '#1d2934' }}>Name</th>
                <th style={{ padding: '12px', textAlign: 'left', color: '#1d2934' }}>Tier</th>
                <th style={{ padding: '12px', textAlign: 'left', color: '#1d2934' }}>Searches Today</th>
                <th style={{ padding: '12px', textAlign: 'left', color: '#1d2934' }}>Insights Today</th>
              </tr>
            </thead>
            <tbody>
              {allUsers.map((u) => (
                <tr key={u.id} style={{ borderBottom: '1px solid #e0e0e0' }}>
                  <td style={{ padding: '12px', color: '#474f58' }}>{u.email}</td>
                  <td style={{ padding: '12px', color: '#474f58' }}>{u.full_name}</td>
                  <td style={{ padding: '12px', color: '#474f58' }}>
                    <span style={{
                      background: u.tier === 'pro' ? '#53dafc' : u.tier === 'premium' ? '#545f6b' : '#e0e0e0',
                      color: u.tier === 'free' ? '#1d2934' : 'white',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '14px'
                    }}>
                      {u.tier}
                    </span>
                  </td>
                  <td style={{ padding: '12px', color: '#474f58' }}>{u.searches_today || 0}</td>
                  <td style={{ padding: '12px', color: '#474f58' }}>{u.insights_today || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}

export default AdminPage;
